export type FeeItem = {
  id: string;
  label?: string;
  /** LLM backfills sometimes emit title instead of label on line items */
  title?: string;
  amount: number | null;
  min_amount?: number | null;
  max_amount?: number | null;
  frequency?: string;
  /** Shown on hover/tap when label has a dotted underline */
  tooltip?: string;
  refundable?: boolean;
  /** Max units allowed for this add-on (e.g. 2 pets). Empty / 0 = not shown. */
  max_quantity?: number | null;
  /** "usage" = no fixed price; shown as "Varies by usage". Omitted = fixed amount. */
  pricing_type?: "usage";
  /** Backend-injected only (never authored) -- shown as a second, distinct tooltip icon. */
  nationality_note?: string;
};

export type FeeSubgroup = {
  id: string;
  title: string;
  items: FeeItem[];
  note?: string;
};

export type FeeCategory = {
  id: string;
  title: string;
  subtitle: string;
  items?: FeeItem[];
  subgroups?: FeeSubgroup[];
  note?: string;
  defaultExpanded?: boolean;
};

export type FeesSectionData = {
  id: string;
  title: string;
  categories: FeeCategory[];
};

export type ConditionalNotes = Record<string, string>;

export const getFeeItemLabel = (item: Pick<FeeItem, "label" | "title">): string =>
  item.label?.trim() || item.title?.trim() || "";

/** Saved add-on groups still store id/title "penalties". Show Situational without a resave. */
export const displayAddOnCategoryTitle = (category: Pick<FeeCategory, "id" | "title">): string => {
  const id = category.id?.trim().toLowerCase();
  const title = category.title?.trim().toLowerCase();
  if (id === "penalties" || title === "penalties" || title === "penalty") {
    return "Situational";
  }
  return category.title;
};
